export default function monthlyParkingTotalCalculations(subscriptions = []) {
    const normalize = (v) => (v || "").toLowerCase();

    const totals = {
        totalCash: 0,
        totalCheque: 0,
        totalStripe: 0,
        totalQbo: 0,
        totalUnknown: 0,
    };

    subscriptions.forEach((s) => {
        const type = normalize(s.payment_type);
        const total = s.total || 0;

        if (type === "cod") totals.totalCash += total;
        else if (type === "cheque") totals.totalCheque += total;
        else if (type.startsWith("stripe")) totals.totalStripe += total;
        else if (type.startsWith("qbo")) totals.totalQbo += total;
        else totals.totalUnknown += total;
    });

    totals.totalCollected =
        totals.totalCash +
        totals.totalCheque +
        totals.totalStripe +
        totals.totalQbo +
        totals.totalUnknown;

    return totals;
}